export default {
  data () {
    return {
      momentStatusCache: new Map() // Cache for moment statuses
    }
  },

  methods: {
    getMomentStatus (moment) {
      // Use cached status if available
      const cacheKey = `${moment.extendedProps.ActivityID}-${moment.extendedProps.WarehouseID}-${moment.id}`
      if (this.momentStatusCache.has(cacheKey)) {
        return this.momentStatusCache.get(cacheKey)
      }

      const status = this.getReservationStatus(moment)
      this.momentStatusCache.set(cacheKey, status)
      return status
    },

    getReservationStatus (moment) {
      // Check if moment has children and if any of them are reservable
      if (moment.children?.length && !this.isStackedMomentsModal) {
        const hasReservableChild = moment.children.some(child => {
          const childStatus = this.getReservationStatus(child)
          return childStatus?.canReserve
        })

        if (hasReservableChild) {
          return {
            variant: 'outline-success',
            text: this.$t('actions.reserve'),
            canReserve: true,
            hasMultipleOptions: moment?.children?.length
          }
        } else {
          // No reservable children, but we have children - show blocks button
          return {
            variant: 'outline-primary',
            text: this.$t('timetable.blocks'),
            canReserve: true,
            hasMultipleOptions: moment?.children?.length
          }
        }
      }

      const now = new Date()
      // now.setHours(12, 35, 0) // Debug

      const endDateTime = new Date(moment.end)

      const reservationStart = moment.extendedProps.ReservationStartDate
        ? new Date(moment.extendedProps.ReservationStartDate)
        : null
      const reservationEnd = moment.extendedProps.ReservationEndDate
        ? new Date(moment.extendedProps.ReservationEndDate)
        : null

      // Check reservation window if defined
      if ((moment.extendedProps.ReservationStartDate || moment.extendedProps.ReservationEndDate) && this.isStackedMomentsModal) {
        // If before reservation start date
        if (reservationStart && now < reservationStart) {
          return {
            identification: 'reservations_open_at',
            variant: 'outline-dark',
            text: this.$t('timetable.not_yet_available'),
            date: reservationStart,
            canReserve: false
          }
        }

        // If after reservation end date
        if (reservationEnd && now > reservationEnd) {
          return {
            identification: 'reservations_closed_at',
            variant: 'outline-dark',
            text: this.$t('timetable.not_available_anymore'),
            date: reservationEnd,
            canReserve: false
          }
        }
      }

      if (
        (reservationStart && now < reservationStart) ||
        (reservationEnd && now > reservationEnd)
      ) {
        // We are outside the reservation range, do not offer the option to reserve
        return null
      }

      // Check if expired
      if (now > endDateTime) {
        return {
          variant: 'outline-dark',
          text: this.$t('timetable.expired'),
          canReserve: false
        }
      }

      // Check if MaxEntryQuantity is enabled
      if (!moment.extendedProps.MaxEntryQuantity) {
        return null
      }

      // Check max quantity and queue settings
      const maxQuantityReached = Number(moment.extendedProps.CurrentEntryQuantity || 0) >= Number(moment.extendedProps.MaxEntryQuantity || 0)
      const attendanceQueueEnabled = moment.extendedProps['Activity.QueueAttendanceYN']

      if (Number(moment.extendedProps.MaxEntryQuantity || 0) > 0 && maxQuantityReached) {
        if (attendanceQueueEnabled) {
          return {
            variant: 'warning',
            text: this.$t('reservation.queue'),
            canReserve: true,
            showQueueCount: true
          }
        } else {
          return {
            variant: 'outline-dark',
            text: this.$t('timetable.timeslot_full'),
            canReserve: false
          }
        }
      }

      // Default case - can reserve
      return {
        variant: 'outline-success',
        text: this.$t('actions.reserve'),
        canReserve: true
      }
    }
  }
}
